import {
  Component,
  OnInit
} from "@angular/core";
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { InReportService } from '../../services/inventory/in-report.service'
import { CaMasterService } from '../../services/accounts/ca-master.service'
import { LoyaltyService } from '../../services/Loyalty/loyalty.service'
import { DataService } from '../../services/data.service'
import { environment } from "../../../../environments/environment";
import { MainService } from "../../services/main.service";
import { DatePipe } from '@angular/common';
import { CaTransService } from '../../services/accounts/ca-trans.service';
export interface ParmModel {
  title: string;
  Items: any;
}
@Component({
  selector: 'app-rpt-fiter',
  templateUrl: './rpt-fiter.component.html',
  styleUrls: ['./rpt-fiter.component.css']
})
export class RptFiterComponent extends DialogComponent<ParmModel, boolean>
  implements ParmModel, OnInit {
  title: string;
  Items: any;
  result: any = { result: false, RtnItem: {} };
  loading: boolean = false;
  loadResult: any;
  selectd: string;
  load: any = [];
  type: any = [];
  branchList: any = [];
  branchIn: string = "";
  LocIds: string = ""
  LocationList: any = [];
  isClose: boolean = true;
  AccountsOpBalanceBeforeOneDate: boolean = false;
  isConsolidated: boolean = false;

  constructor(dialogService: DialogService, private ir: InReportService, private ds: DataService, private ca: CaMasterService,
    private ls: LoyaltyService, private main: MainService, public datepipe: DatePipe, private tran: CaTransService) {
    super(dialogService);
  }

  ngOnInit() {
    var isx = (this.ds.Settings.AccountsOpBalanceBeforeOneDate)
    this.AccountsOpBalanceBeforeOneDate = isx.toLowerCase() == 'true'
    for (let i of this.Items) {
      this.result.RtnItem[i.Name] = i.Value;
      if (i.Type == 'ledger') {
        if (i.ByVal) {
          this.GetLedgerbyGroup(i.ByTo);
        } else {
          this.GetLedger();
        }
      } else if (i.Type == 'Group') {
        this.GetGroup();
      }
      else if (i.Type == 'Member') {
        this.GetMember();
      }
      else if (i.Type == 'Type') {
        this.getLedgerType();
      }
      else if (i.Type == 'branchList') {
        this.LoadAllBranch();
      }
      if (i.Type == 'ConsolidateBranch') {
        if (i.Value) {
          var a = i.Value.split(',');
          for (let it of a) {
            if (it == "") {
              continue;
            }
            this.GetLocationByBranch(it);
          }
        }
        this.isConsolidated = true;
      }

    }
    if (!this.isConsolidated) {
      this.GetLocationByBranch(this.ds.Settings.BranchId);
    }

    this.isClose = true;
  }


  ok() {
    for (let i of this.Items) {
      if (i.Type == 'date') {
        var date = new Date(this.result.RtnItem[i.Name]);
        this.result.RtnItem[i.Name] = date.toDateString();
      } else if (i.Type == 'ledger') {
        this.result.RtnItem[i.Name] = i.Value;
        this.isClose = true;
      } else if (i.Type == 'Group') {
        this.result.RtnItem[i.Name] = i.Value;
      } else if (i.Type == 'Name') {
        this.result.RtnItem[i.Name] = this.selectd;
      }
      else if (i.Type == 'Member') {
        this.result.RtnItem[i.Name] = i.Value;
        this.isClose = true;
      }
      else if (i.Type == 'Type') {
        this.result.RtnItem[i.Name] = i.Value;
      }
      else if (i.Type == 'branchList') {
        if (this.branchIn == "") {
          alert("Please select branch");
          this.isClose = false;
        }
        else {
          this.branchIn = this.branchIn.substring(0, this.branchIn.length - 1);
          this.result.RtnItem[i.Name] = this.branchIn;
          this.isClose = true;
        }
      }
    }
    if (this.isClose) {
      this.result.result = true;
      this.close();
    }
  }
  btnClick() {
    this.loading = true;
    this.LoadData();
  }
  GetMember() {
    var filterText = {
      Start: 0,
      FiterText: "",
      Limit: this.ds.Settings.MaxLimit,
      ItemTypeId: this.ds.Settings.ItemTypeId,
      CAType: this.ds.Settings.CAType
    }
    this.ls.GetMember(filterText).subscribe(res => {
      if (res.Success) {
        this.loadResult = []
        for (let i of res.data) {
          this.loadResult.push({ MemberId: i.MemberId, Name: i.Name + " - " + i.Mobile })
        }

      }

    })
  }
  GetLedger() {
    var data = {
      Start: 0,
      FiterText: "",
      Limit: this.ds.Settings.MaxLimit,
      ItemTypeId: this.ds.Settings.ItemTypeId,
      CAType: this.ds.Settings.CAType
    }
    this.ca.GetLedger(data).subscribe(res => {
      if (res.Success) {
        for (let i of res.data) {
          i.Name = i.Code + "-" + i.Name
        }
        this.loadResult = res.data;
      }
    })
  }
  selected(e) {
    this.selectd = e.Name;
    if (e.Type) {
      if (e.Type == "Branch") {
        this.branchIn = this.branchIn + e.Id + ","
        this.GetLocationByBranch(e.Id)
        this.LocIds = this.LocIds.substring(0, this.LocIds.length - 1);
      }

    }
    if (this.LocIds == "") {
      this.isClose = false;
    }
    else {
      this.isClose = true;
    }
  }
  GetLedgerbyGroup(grpId) {
    var data = {
      GroupId: grpId,
      RequestDataList: {
        Start: 0,
        FiterText: "",
        Limit: this.ds.Settings.MaxLimit,
        ItemTypeId: this.ds.Settings.ItemTypeId,
        CAType: this.ds.Settings.CAType
      }
    }
    this.ca.GetLedgerByGroupId(data).subscribe(res => {
      if (res.Success) {
        for (let i of res.data) {
          i.Name = i.Code + "-" + i.Name
        }
        this.loadResult = res.data;
      }
    })
  }
  GetGroup() {
    var data = {
      Start: 0,
      FiterText: "",
      Limit: this.ds.Settings.MaxLimit,
      ItemTypeId: this.ds.Settings.ItemTypeId,
      CAType: this.ds.Settings.CAType
    }
    this.ca.GetCAGroup(data).subscribe(res => {
      if (res.Success) {
        this.loadResult = res.data;
      }
    })
  }
  LoadData() {
    if (this.LocIds == "") {
      //this.LocIds = this.ds.Settings.LocationId
      this.GetLocationByBranch(this.ds.Settings.BranchId);
    }
    for (let i of this.Items) {
      if (i.Calc == 'stock') {
        var data = {
          FromDate: new Date(this.result.RtnItem[i.Date]),
          LocationId: this.LocIds
        }
        this.ir.getClosingStock(data).subscribe(res => {
          if (res.Success) {
            this.result.RtnItem[i.Name] = res.data.toFixed(environment.noofdecimal);
            i.Value = res.data;
          }
          this.load[i.Name] = false;
          this.getdate();
        });
      }
      else if (i.Calc == 'opstock') {
        if (this.AccountsOpBalanceBeforeOneDate) {
          var fromdate = new Date();
          var newdate = new Date();
          fromdate = new Date(this.result.RtnItem[i.Date]);
          newdate = new Date(fromdate.setDate(fromdate.getDate() - 1));
          var data = {
            FromDate: newdate,
            LocationId: this.LocIds
          }
          this.ir.getClosingStock(data).subscribe(res => {
            if (res.Success) {
              this.result.RtnItem[i.Name] = res.data.toFixed(environment.noofdecimal);
              i.Value = res.data;
            }

            this.load[i.Name] = false;
            this.getdate();
          });
        }
        else {
          var data = {
            FromDate: new Date(this.result.RtnItem[i.Date]),
            LocationId: this.LocIds
          }
          this.ir.getClosingStock(data).subscribe(res => {
            if (res.Success) {
              this.result.RtnItem[i.Name] = res.data.toFixed(environment.noofdecimal);
              i.Value = res.data;
            }

            this.load[i.Name] = false;
            this.getdate();
          });
        }

      }
      else if (i.Calc == 'salesvalue') {
        var d = {
          FromDate: new Date(this.result.RtnItem[i.Date]),
          ToDate: new Date(this.result.RtnItem[i.ToDate]),
          BranchId: this.ds.Settings.BranchId
        }
        this.tran.Get_DataForPerformanceReport(d).subscribe(res => {
          if (res.Success) {
            this.result.RtnItem[i.Name] = Number(res.data.SalesAmt).toFixed(environment.noofdecimal);
            i.Value = Number(res.data.SalesAmt);
          }

          this.load[i.Name] = false;
          this.getdate();
        });
      }
      else if (i.Calc == 'costvalue') {
        var d = {
          FromDate: new Date(this.result.RtnItem[i.Date]),
          ToDate: new Date(this.result.RtnItem[i.ToDate]),
          BranchId: this.ds.Settings.BranchId
        }
        this.tran.Get_DataForPerformanceReport(d).subscribe(res => {
          if (res.Success) {
            this.result.RtnItem[i.Name] = Number(res.data.Cost).toFixed(environment.noofdecimal);
            i.Value = Number(res.data.Cost);
          }

          this.load[i.Name] = false;
          this.getdate();
        });
      }
    }
  }
  getdate() {
    if (this.load.length = 2) {
      this.loading = this.load[0] == this.load[1] ? this.load[0] : !this.load[0]
    }
    else if (this.load.length = 1) {
      this.loading = this.load[0]
    }
  }
  getLedgerType() {
    this.type.push({ Id: 1, Name: "Default" }, { Id: 2, Name: "Detailed" }, { Id: 3, Name: "Oposite Entry" })
  }
  LoadAllBranch() {
    var data = {
      "CompanyId": this.ds.Settings.CompanyId,
      "RequestedList": {
        "Start": 0,
        "FiterText": "",
        "Limit": this.ds.Settings.MaxLimit,
        "ItemTypeId": this.ds.Settings.ItemTypeId,
        "CAType": this.ds.Settings.CAType
      }
    }
    this.main.GetBranch(data).subscribe(
      res => {
        if (res.Success) {
          for (let i of res.data) {
            this.branchList.push({ Id: i.Id, Name: i.Name, Type: "Branch" })
          }
          this.loadResult = this.branchList;
          // this.branchList = res;

        }
      },
      error => {

      }
    );
  }
  GetLocationByBranch(Id) {
    var data = {
      "BranchId": Id,
      "RequestedList": {
        "Start": 0,
        "FiterText": "",
        "Limit": this.ds.Settings.MaxLimit,
        "ItemTypeId": this.ds.Settings.ItemTypeId,
        "CAType": this.ds.Settings.CAType
      }
    }
    this.main.GetLocationBybranch(data).subscribe(
      res => {
        if (res.Success) {
          for (let i of res.data) {
            this.LocIds = i.Id + "," + this.LocIds
          }
          //this.LocIds=this.LocIds.replace(/,\s*$/, "");
        }
      },
      error => {

      }
    );
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/rpt-fiter/rpt-fiter.component.ts